// extracted by mini-css-extract-plugin
module.exports = {"agreement":"agreement_agreement__YoM2I","agreementContainer":"agreement_agreementContainer__1gyLI"};